var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconDarkmode48Filled = function SvgIconDarkmode48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: "current",
    viewBox: "0 0 47 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.773 27.844a2 2 0 0 0-2.39-.22 10.14 10.14 0 0 1-12.37-15.88 2.05 2.05 0 0 0-1.78-3.48 15.73 15.73 0 0 0-8.86 4.64 16.06 16.06 0 0 0-.32 21.68 15.74 15.74 0 0 0 11.35 5.18h.37a15.72 15.72 0 0 0 11.2-4.64 15.512 15.512 0 0 0 3.32-4.9 2 2 0 0 0-.52-2.38Z",
    fill: "current"
  })));
};
export default SvgIconDarkmode48Filled;